export const navItems = [
  { content: "الكتب", href: "/books" },
  { content: "التدوينات", href: "/posts" },
  { content: "بوكلاود بلاس", href: "/bookCloudPlus" },
];
